import * as React from 'react'
import { Button } from 'antd'
import { FC } from 'react'

interface PowCloudButtonProps {
  background?: string
  color?: string
  htmlType?: 'submit' | 'button'
  label: string
  onClick?: () => void
}

export const PowCloudButton: FC<PowCloudButtonProps> = ({
  background = '#0075a8',
  color = '#FFF',
  htmlType = 'submit',
  label,
  onClick,
}: PowCloudButtonProps) => (
  <Button
    style={{
      color: color,
      fontSize: '0.9rem',
      background: background,
      borderRadius: '21.5px',
      border: 0,
      fontWeight: 600,
    }}
    htmlType={htmlType}
    onClick={onClick}
  >
    {label}
  </Button>
)
